function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgSales = function SvgSales(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 514.0009765625 514.0009765625",
    xmlSpace: "preserve",
    y: "0px",
    x: "0px",
    id: "Capa_1_1565754628954",
    width: 62.752446619217096,
    height: 60.406396881067,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1, 1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M251.371,432.79c-1.86-1.86-4.44-2.931-7.07-2.931s-5.21,1.07-7.07,2.931c-1.86,1.859-2.93,4.439-2.93,7.069    c0,2.641,1.07,5.21,2.93,7.07c1.86,1.87,4.44,2.93,7.07,2.93s5.21-1.06,7.07-2.93c1.86-1.86,2.93-4.439,2.93-7.07    C254.301,437.229,253.23,434.649,251.371,432.79z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M298.983,340.539v-73.582c0-3.322-1.65-6.428-4.403-8.287c-2.753-1.859-6.25-2.229-9.333-0.989l-172.313,69.397h-55.5    c-31.668,0-57.433,25.765-57.433,57.435c0,31.67,25.765,57.435,57.435,57.435h6.609V502c0,5.522,4.477,10,10,10h40.824    c5.523,0,10-4.478,10-10v-55.228l160.383,64.506c1.203,0.484,2.47,0.723,3.73,0.723c1.968,0,3.922-0.581,5.6-1.714    c2.752-1.859,4.401-4.965,4.401-8.286V428.42c20.054-4.563,35.072-22.525,35.072-43.94    C334.055,363.065,319.037,345.102,298.983,340.539z M104.868,492H84.045v-50.053h20.824V492z M104.87,421.947H57.436    c-20.642,0-37.435-16.793-37.435-37.434c0-20.642,16.793-37.435,37.435-37.435h47.438L104.87,421.947z M278.984,487.199h-0.001    l-154.109-61.983V343.83l109.427-44.07V399c0,5.522,4.477,10,10,10c5.523,0,10-4.478,10-10V291.705l24.683-9.941V487.199z     M298.983,407.464v-45.97c8.861,3.87,15.072,12.714,15.072,22.985C314.055,394.75,307.845,403.594,298.983,407.464z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M429.453,374.775h-56.618c-5.523,0-10,4.478-10,10c0,5.522,4.477,10,10,10h56.618c5.523,0,10-4.478,10-10    C439.453,379.253,434.976,374.775,429.453,374.775z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M383.02,301.498c-3.905-3.904-10.237-3.904-14.143,0l-19.53,19.53c-3.905,3.905-3.905,10.237,0,14.143    c1.954,1.952,4.513,2.929,7.072,2.929c2.559,0,5.119-0.977,7.071-2.929l19.53-19.53    C386.925,311.736,386.925,305.404,383.02,301.498z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M383.754,452.976l-20.183-20.184c-3.905-3.904-10.237-3.904-14.143,0c-3.905,3.905-3.905,10.237,0,14.143l20.184,20.184    c1.953,1.952,4.512,2.929,7.071,2.929s5.119-0.977,7.071-2.929C387.659,463.214,387.659,456.882,383.754,452.976z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M472.001,0h-186c-22.056,0-40,17.944-40,40v4h-168c-13.234,0-24,10.767-24,24v158c0,13.233,10.766,24,24,24h10.333v30.667    c0,4.045,2.437,7.691,6.173,9.239c1.237,0.512,2.536,0.761,3.825,0.761c2.602,0,5.16-1.016,7.073-2.929L143.143,250h198.638    c13.234,0,24-10.767,24-24v-30h106.22c22.056,0,40-17.944,40-40V40C512,17.944,494.057,0,472.001,0z M345.781,226    c0,2.206-1.794,4-4,4h-202.78c-2.652,0-5.196,1.054-7.071,2.929l-23.595,23.596V240c0-5.522-4.477-10-10-10H78.001    c-2.206,0-4-1.794-4-4V68c0-2.206,1.794-4,4-4h168v92c0,22.056,17.944,40,40,40h59.78V226z M492.001,156c0,11.028-8.972,20-20,20    h-186c-11.028,0-20-8.972-20-20V40c0-11.028,8.972-20,20-20h186c11.028,0,20,8.972,20,20V156z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M419.176,89.34l-68.44-39.514c-3.094-1.787-6.906-1.787-10,0c-3.094,1.786-5,5.088-5,8.66v79.027    c0,3.572,1.906,6.874,5,8.66c1.547,0.894,3.273,1.34,5,1.34s3.453-0.446,5-1.34l68.44-39.514c3.094-1.786,5-5.088,5-8.66    C424.176,94.427,422.271,91.126,419.176,89.34z M355.736,120.193V75.807L394.176,98L355.736,120.193z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M214.512,105h-100c-5.523,0-10,4.478-10,10c0,5.522,4.477,10,10,10h100c5.523,0,10-4.478,10-10    C224.512,109.478,220.035,105,214.512,105z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M221.581,163.93c-1.86-1.861-4.44-2.93-7.07-2.93s-5.21,1.069-7.07,2.93c-1.86,1.86-2.93,4.44-2.93,7.07    s1.07,5.21,2.93,7.069c1.86,1.86,4.44,2.931,7.07,2.931c2.64,0,5.21-1.07,7.07-2.931c1.86-1.859,2.93-4.439,2.93-7.069    S223.441,165.79,221.581,163.93z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M177.001,161h-62.489c-5.523,0-10,4.478-10,10c0,5.522,4.477,10,10,10h62.489c5.523,0,10-4.478,10-10    C187.001,165.478,182.524,161,177.001,161z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSales, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sales.16b11d99.svg";
export { ForwardRef as ReactComponent };